/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Boundary_MessageInputs */

const nl_common_error_boundary_message = /** @type {(inputs: Common_Error_Boundary_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er ging iets mis. Ververs de pagina en probeer het opnieuw.`)
};

/**

* @param {Common_Error_Boundary_MessageInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_error_boundary_message = /** @type {((inputs?: Common_Error_Boundary_MessageInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Boundary_MessageInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_error_boundary_message(inputs)
});
export { common_error_boundary_message as "common.error_boundary_message" }